// extracted by mini-css-extract-plugin
export default {"container":"style_container__pojRq","titleSection":"style_titleSection__hneX7"};